export default __webpack_public_path__ + "static/media/ndl_logo.70ff2b8c.svg";